export default __webpack_public_path__ + "static/media/doctor.fe70df5e.png";